import { Typography } from "@mui/material";
import { UpdateCaseDataExecutionStepPayload } from "../../../types/ExecutionJob/UpdateCaseDataExecutionStepPayload";
import { formatTemporalValue } from "../../../services/dateConverter";

type CaseDataChangePreviewProps = {
  preview: UpdateCaseDataExecutionStepPayload["preview"];
};

export default function CaseDataChangePreview({ preview }: CaseDataChangePreviewProps) {
  return (
    <>
      <Typography variant="subtitle2">{preview.section}</Typography>
      {(preview.fields.length !== 1 || preview.fields[0].label !== preview.target) && (
        <Typography variant="body2">{preview.target}</Typography>
      )}
      {preview.fields.map((field) => (
        <Typography key={field.label} variant="body2" color="text.secondary">
          {field.label}: {preview.operation === "update" && `${formatTemporalValue(field.oldValue, field.format ?? null) || "Leer"} → `}
          {formatTemporalValue(field.newValue, field.format ?? null)}
        </Typography>
      ))}
    </>
  );
}
